import Page from 'component/page-container'
import { HashLink as NavLink } from 'react-router-hash-link';
import Tag from 'component/tag'


const AboutRoute = () => (
    <Page className="about-page" h1="О клубе">
        <div className="page__inner">
            <p>Мы клуб вокруг занятий и процессов. Несложный ценз на вход обязывает вас самостоятельно добиться расположения остальных. Представьте себя на фуршете с интересными людьми: они открыты к диалогу, но вас не знают.</p>
            <p>Участники клуба вольны обмениваться вещами, деньгами, идеями; создавать процессы, и принимать участие в существующих; общаться, наконец.</p>
            <p>«Сочтёмся», совместные покупки, семейная подписка на Нетфликс, настолки у кого-то дома — вы сами решаете когда и с кем готовы пойти на такое. Клуб ни к чему не обязывает. Главный смысл клуба — взаимовыгода и веселье.</p>
            <p>Если вы не приносите веселье и только извлекаете выгоду, ничего не давая взамен <a href="https://lesswrong.ru/w/%D0%9F%D0%B0%D1%86%D0%B8%D1%84%D0%B8%D0%B7%D0%BC_%D0%B3%D1%83%D0%B1%D0%B8%D1%82_%D1%83%D1%85%D0%BE%D0%B6%D0%B5%D0%BD%D0%BD%D1%8B%D0%B5_%D1%81%D0%B0%D0%B4%D1%8B">мы попросим вас уйти</a>. Все в клубе умные и добрые, а за вас поручился ваш друг. Однако, это не гарантирует, что вас примет сообщество.</p>
            <p>Важно лично привести новичка и помочь ему. Без вас ему будут гораздо меньше доверять.</p>

            <p><br /></p>

            <div className="container">
                <h2>Что у нас есть</h2>
                <div>
                    <h4><NavLink to="/process">Процессы</NavLink></h4>
                    <p>У нас есть механика создания отдельных комнаток (процессов) для разных занятий. Такие группочки по интересам. Каждая комната — отдельный чатик, доступный только его участникам. Можно показать его всему клубу, но по умолчанию любой процесс — приватный.</p>
                </div>
                <div>
                    <h4>Новости</h4>
                    <p>Чатов много, сообщений много. Чтобы важное не терялось, бот выбирает посты с тегом <Tag>#новость</Tag> и постит их в канал, прикрепленный к чатику. Можно и самим постить напрямую в канал, но только действительно важное. Лучше через тег и бота.</p>
                    <p><NavLink to="/bots#news_club_bot">Бот Хранитель новостей</NavLink></p>
                </div>
                <div>
                    <h4><NavLink to="/events">События</NavLink></h4>
                    <p>Бот создают события приямо из чатов и дообавляют их в календари процессов. На календари можно подписаться, чтобы новые события появлялись автоматически. События и календари видны только участникам чата/процесса, из которого они созданы.</p>
                </div>
                <div>
                    <h4><NavLink to="/recommendation">Рекомендации</NavLink></h4>
                    <p>Мнение участников клуба — важно. Советуем друг другу фильмы, сериалы, книги, игры, бары, рестораны, интересные места и любые другие кллассные штуки.</p>
                </div>
                <div>
                    <h4>Стикеры</h4>
                    <p>
                        Конечно же, у нас есть <NavLink to="/bots#sticker_club_bot">бот, который делает из сообщений стикеры</NavLink>.
                </p>
                </div>
                <div>
                    <h4><a href="https://docs.google.com/spreadsheets/d/1iRJMHf6tsYLcPds-YU1tBuSU72eygfai2ZvCLRUc42Y/edit#gid=0" target="_blank" rel="noreferrer">Шеринг вещей</a></h4>
                    <p>Делимся вещами на время или насовсем.</p>
                </div>
                <div>
                    <h4><NavLink to="/discounts">Скидки</NavLink></h4>
                    <p>Пока вяленько, но делимся скидками.</p>
                </div>
            </div>

            <p><br /></p>

            <div className="container">
                <h2>Как выжить с кучей чатов</h2>
                <p>— Мьютить;</p>
                <p>— Архивировать (будут маячить только когда вы упомянуты);</p>
                <p>— Складывать в отдельную папку (Телеграм умеет);</p>
                <p>— Не подписываться на все подряд. У нас много чатов, не все из них нужны именно вам.</p>
            </div>

            <p><br /></p>

            <div className="container">
                <h2>Как приглашать новых участников</h2>
                <p>Регистрация временно открыта: <NavLink to="/invite">инвайты</NavLink></p>
            </div>
        </div>
    </Page>
)

export default AboutRoute
